import { render } from "./createQuestion1.vue?vue&type=template&id=653251cd&scoped=true"
import script from "./createQuestion1.vue?vue&type=script&lang=js"
export * from "./createQuestion1.vue?vue&type=script&lang=js"

import "./createQuestion1.vue?vue&type=style&index=0&id=653251cd&lang=less&scoped=true"
import "./createQuestion1.vue?vue&type=style&index=1&id=653251cd&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653251cd"]])

export default __exports__